export const APP_VERSION = "1.1"; // Define the app version here